import script from "./AccountCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountCard.vue?vue&type=script&setup=true&lang=ts"

import "./AccountCard.vue?vue&type=style&index=0&id=de796f36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de796f36"]])

export default __exports__